import type { CategoryGridItem } from "@ui/components/core/CategoryGrid/CategoryGrid";

import { CategoryGrid } from "@ui/components/core/CategoryGrid";
import { EventName } from "@mw/shared/analyticsEventNames";

export function MusicSimilarCollectionsGrid({ items }: { items: CategoryGridItem[] }) {
  const trackedItems = items.map((item, index) => ({
    ...item,
    eventName: EventName.mw_music_category_similar_clicked,
    eventProperties: {
      slug: item.href?.split("/").pop() ?? "",
      title: item.title,
      position: index,
    },
  }));
  return <CategoryGrid items={trackedItems} />;
}
